import React, { Component } from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton,
} from 'react-accessible-accordion';
// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';


class Accordion01 extends Component {
    render(){
        return(
            <Accordion className="accodion-style--1" preExpanded={'0'}>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  Mejora tus habilidades empresariales constantemente.
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  Las mejores marcas son aquellas que se reinventan constantemente. Te ayudamos a identificar nuevas oportunidades para que tu negocio nunca deje de crecer.
                </p>
              </AccordionItemPanel>
            </AccordionItem>
          
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  Tácticas que pueden hacer crecer tu negocio.
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  Implementamos estrategias innovadoras que combinan creatividad y datos para posicionar tu marca de forma efectiva en el mercado.
                </p>
              </AccordionItemPanel>
            </AccordionItem>
          
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  El secreto para un negocio exitoso.
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  La clave del éxito empresarial está en una combinación efectiva de estrategia, innovación y una ejecución impecable. Nosotros te guiamos en cada paso.
                </p>
              </AccordionItemPanel>
            </AccordionItem>
          
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  Cómo iniciar y hacer crecer un negocio.
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  Desde la planificación inicial hasta la expansión, te ayudamos a construir una marca sólida que destaque y prospere en su sector.
                </p>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          
        )
    }
}

export default Accordion01;





